/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TenantDtoPage } from '../../models/tenant-dto-page';

export interface ListTenants$Params {
  isTemplate?: boolean | null;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'name' | '-name' | 'hostName' | '-hostName' | 'isTemplate' | '-isTemplate' | 'branding' | '-branding' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listTenants(http: HttpClient, rootUrl: string, params?: ListTenants$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listTenants.PATH, 'get');
  if (params) {
    rb.query('isTemplate', params.isTemplate, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TenantDtoPage>;
    })
  );
}

listTenants.PATH = '/v0/tenants';
